module.exports = __webpack_public_path__ + "img/tameimpala.69f89c4f.svg";